/* unplugin-vue-components disabled */import script from "./toggleBindModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./toggleBindModal.vue?vue&type=script&lang=ts&setup=true"

import "./toggleBindModal.vue?vue&type=style&index=0&id=05a15f40&lang=less&scoped=true"

import exportComponent from "/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.4.21_vue@3.4.21_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a15f40"]])

export default __exports__